var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDarkMode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3816 14.8808C17.9325 14.9592 17.4708 15 17 15C12.5817 15 9 11.4183 9 7C9 6.52916 9.04084 6.06747 9.11916 5.6184C6.69015 6.71665 5 9.16094 5 12C5 15.866 8.13401 19 12 19C14.8391 19 17.2834 17.3099 18.3816 14.8808ZM18.9684 12.6697C18.3518 12.8837 17.6895 13 17 13C13.6863 13 11 10.3137 11 7C11 6.31053 11.1163 5.64822 11.3303 5.03162C11.3469 4.98378 11.3641 4.93622 11.3819 4.88894C11.5427 4.46135 11.7508 4.05697 12 3.68221C12.0607 3.59087 12.1239 3.5013 12.1894 3.41358C12.314 3.24672 12.2082 3 12 3C11.881 3 11.7626 3.00231 11.6448 3.00688C11.1677 3.0254 10.7002 3.08105 10.245 3.17103C10.1423 3.19132 10.0403 3.21336 9.93891 3.23711C5.96166 4.16896 3 7.73861 3 12C3 16.9706 7.02944 21 12 21C16.2614 21 19.831 18.0383 20.7629 14.0611C20.7866 13.9597 20.8087 13.8577 20.829 13.755C20.9189 13.2998 20.9746 12.8323 20.9931 12.3552C20.9977 12.2374 21 12.119 21 12C21 11.7918 20.7533 11.686 20.5864 11.8106C20.4987 11.8761 20.4091 11.9393 20.3178 12C19.943 12.2492 19.5386 12.4573 19.1111 12.6181C19.0638 12.6359 19.0162 12.6531 18.9684 12.6697Z",
    fill: "#565A5E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDarkMode);
export default __webpack_public_path__ + "static/media/icon-dark-mode.148a123bfaded773f20f3ed507d8316d.svg";
export { ForwardRef as ReactComponent };